/*
 * Copyright (c) 2018 Integral Agile, Inc. All rights reserved.
 *   Use of this file is subject to the terms and conditions defined in the file
 * 'LICENSE.txt'
 *   which is distributed in the root directory of this source code tree.
 */

import React from 'react';
import PropTypes from 'prop-types';
import { CadenceStatuses } from '../../constants/storyStatusTypes';
import CustomSelect from '../Common/CustomSelect/SelectField';

const ResultCadenceSelect = (props) => {
  const { workPackage, cadenceList, allowEdit, onSelect } = props;

  const handleCadenceChange = (option) => {
    const { cadence_ids } = workPackage;
    if (cadence_ids.includes(option.value)) return;

    if (option.value) {
      if (cadence_ids.length) {
        props.removeWorkPackageFromCadence(workPackage.id, cadence_ids[0] );
      }
      props.addWorkPackageToCadence(workPackage.id, option.value);
    } else {
      props.removeWorkPackageFromCadence(workPackage.id, cadence_ids[0]);
    }
  };

  const handleSelection = (option) => {
    onSelect(option.value, 'cadence_id');
  };

  const cadenceIds = workPackage.cadence_ids || [];

  const cadencesNotAccepted = cadenceList.cadences.filter(
    (c) => c.status !== CadenceStatuses.ACCEPTED
  );

  const cadence =
    cadencesNotAccepted.find((c) => cadenceIds.indexOf(c.id) !== -1) || {};

  const selectedValue = !workPackage.id
    ? workPackage.cadence_id
    : cadence.id || '';

  const teamCadences = cadencesNotAccepted.filter(
    (cad) => cad.team_id === props.teamSelected.id && !cad.deleted_at
  );

  const defaultOption = { label: 'Choose Sprint', value: null };

  const cadenceOptions = teamCadences.map((teamCadence) => ({
    label: teamCadence.short_name,
    value: teamCadence.id
  }));

  cadenceOptions.unshift(defaultOption);

  let selectedOption;
  if (selectedValue) {
    selectedOption =
      cadenceOptions.find((option) => option.value === selectedValue) ||
      defaultOption;
  } else {
    selectedOption = cadenceOptions.find((option) => option.value === null);
  }
  const onChange = workPackage.id ? handleCadenceChange : handleSelection;
  return (
    <div className="result-cadence-select">
      <label htmlFor="sprint">Sprint</label>
      <CustomSelect
        selectedOption={selectedOption}
        handleOptionChange={onChange}
        disabled={!allowEdit}
        options={cadenceOptions}
        placeholder=""
      />
    </div>
  );
};

ResultCadenceSelect.propTypes = {
  workPackage: PropTypes.object.isRequired,
  cadenceList: PropTypes.object,
  allowEdit: PropTypes.bool,
  addWorkPackageToCadence: PropTypes.func,
  removeWorkPackageFromCadence: PropTypes.func,
  handleFieldChange: PropTypes.func
};

ResultCadenceSelect.defaultProps = {
  cadenceList: {
    cadences: []
  }
};

export default ResultCadenceSelect;
